import { render, staticRenderFns } from "./Valoraciones.vue?vue&type=template&id=349bca72&scoped=true"
import script from "./Valoraciones.vue?vue&type=script&lang=js"
export * from "./Valoraciones.vue?vue&type=script&lang=js"
import style0 from "./Valoraciones.vue?vue&type=style&index=0&id=349bca72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349bca72",
  null
  
)

export default component.exports